<template>
    <div v-if="visible">
        <div class="sheet-wrap" :class="{ display: visible2 }">
            <div class="mask pointer" @click="closeSheet"></div>
            <div
                id="sheet"
                ref="sheet"
                class="sheet"
                :class="[{ animation: animate, disable: !animate }]"
                :style="{ transform: transform }"
            >
                <div class="sheet-inner">
                    <div
                        class="header"
                        v-hammer:panstart="onPanStart"
                        v-hammer:pan="onPanMove"
                        v-hammer:panend="onPanEnd"
                    >
                        <div
                            style="position:absolute; top:8px; left:50%; margin-left:-24px; width:48px; height:5px; border-radius:3px; background:rgba(127,127,127,.2);"
                        ></div>
                    </div>
                    <div
                        class="body"
                        v-if="bodyCanMove"
                        v-hammer:panstart="onPanStart"
                        v-hammer:pan="onPanMove"
                        v-hammer:panend="onPanEnd"
                    >
                        <templateModal
                            v-if="!!visible"
                            :toggleSheet="toggleSheet"
                            v-bind="propsParams"
                        ></templateModal>
                    </div>
                    <div class="body" v-else>
                        <templateModal
                            v-if="!!visible"
                            :toggleSheet="toggleSheet"
                            v-bind="propsParams"
                        ></templateModal>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { mapState } from 'vuex';

export default {
    name: 'sheet',

    components: {
        templateModal: null,
    },
    // props: ['visible', 'height', 'toggleSheet', 'stopTouchSheet'],

    data() {
        return {
            visible: false,
            propsParams: {},
            // startX: 0,
            // startY: 0,
            // touchStartX: 0,
            // touchStartY: 0,
            moveX: 0,
            moveY: 0,
            direction: null,
            movePercentage: 0,
            animate: true,
            height: 0,
            //
            // translateY: 0,
            // animate: true,
            //
            // sheetHeight: 0,
            visible2: false,

            promiseStatus: null,

            disabled: false,
            ev: null,

            bodyCanMove: true,
        };
    },

    computed: {
        transform() {
            if (!this.visible2) {
                return 'translate(-50%, 0)';
            }
            const toPercent = (point) => {
                // var str = Number(point * 100).toFixed(1);
                let str = Number(point * 100);
                str += '%';
                return str;
            };
            const yyoo = toPercent(this.movePercentage - 1);
            const xxoo = `translate(-50%, ${yyoo})`;
            return xxoo;
        },
    },

    mounted() {},

    watch: {
        visible2(newValue, oldValue) {
            if (!!newValue && !oldValue) {
                this.movePercentage = 0;
            }
        },
    },

    methods: {
        stopTouchmove() {
            console.log('stopTouchmove');
        },

        //------------------------------------------------------------
        onPanStart(e) {
            // console.log('onPanStart', e);

            this.height = this.$refs.sheet.clientHeight;
        },

        onPanMove(e) {
            // console.log('......... onPanMove', e);

            if (this.animate) {
                this.animate = false;
            }

            this.moveX = e.deltaX;
            this.moveY = e.deltaY > 0 ? e.deltaY : 0;

            this.movePercentage = this.moveY / this.height;

            if (Math.abs(this.moveY) < Math.abs(this.moveX)) {
                this.direction = 'X';
                this.moveY = 0;
                this.movePercentage = this.moveY / this.height;
            } else {
                this.direction = 'Y';
            }
        },
        onPanEnd(e) {
            // console.log('onPanEnd', e);

            // step 1
            this.animate = true;

            // step 2
            if (this.direction !== 'Y') {
                this.moveY = 0;
                this.movePercentage = this.moveY / this.height;
                return;
            }

            // step 3
            if (this.moveY >= 56) {
                this.moveY = this.height;
                this.movePercentage = this.moveY / this.height;
                this.toggleSheet();
            } else {
                this.moveY = 0;
                this.movePercentage = this.moveY / this.height;
            }
        },
        //------------------------------------------------------------

        toggleSheet() {
            this.visible2 = false;
            setTimeout(() => {
                this.visible = false;
            }, 400);

            this.promiseStatus && this.promiseStatus.resolve({ close: true });
        },

        closeSheet() {
            this.visible2 = false;
            setTimeout(() => {
                this.visible = false;
            }, 400);

            this.promiseStatus && this.promiseStatus.resolve({ close: true });
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@/stylesheets/modules/all';

%absolute {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}

.sheet-wrap {
    @extend %absolute;
    overflow: hidden;
    pointer-events: none;
    z-index: 1000;
    background: transparent;
    &.display {
        pointer-events: auto;
        .mask {
            opacity: 0.18;
        }
    }

    .mask {
        @extend %absolute;
        background-color: $black;
        z-index: 1;
        opacity: 0;
        will-change: transform;
        transition: all 0.5s;
    }
}

.sheet {
    position: absolute;
    top: 100%;
    left: 50%;
    width: 100%;
    max-width: 375px;
    z-index: 2;
    overflow: hidden;
}

.sheet {
    will-change: transform;
    // transition: transform 0.3s;
}

.sheet:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2;
}

.sheet-inner {
    position: relative;
    // background-color: $white;
    border-radius: 8px;
    overflow: hidden;
}

.animation {
    transition: transform ease 0.3s;
}
.sheet.animation:before {
    content: '';
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2;
}

.header {
    position: relative;
    height: 20px;
}

// .sheet-inner {
//     background-color: $LightPrimarySystemBackground;
//     color: $LightPrimaryLabelColor;
// }
//
// @media screen and (prefers-color-scheme: dark) {
//     .sheet-inner {
//         background-color: $ElevatedSecondarySystemGroupedBackground;
//         color: $DarkPrimaryLabelColor;
//     }
// }
</style>
